import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { SetLoading } from '@app/store/app/states/ui/ui.actions';

@Injectable({
  providedIn: 'root',
})
export class GlobalHttpAbortService {
  private globalAbortController = new AbortController();

  constructor(private store: Store) {}

  cancelRequests() {
    this.globalAbortController.abort();
    this.globalAbortController = new AbortController();

    this.store.dispatch(new SetLoading(false));
  }

  getAbortSignal() {
    return this.globalAbortController.signal;
  }
}
